let base_url = "http://47.105.207.4:8088"
//let base_url = "http://127.0.0.1:8000"
//let base_url = "/api"  

export default base_url 


// WEBPACK FOOTER //
// ./src/interface/index.js